import { render } from "./DeleteTaskModal.vue?vue&type=template&id=7c2260e4&scoped=true&ts=true"
import script from "./DeleteTaskModal.vue?vue&type=script&lang=ts"
export * from "./DeleteTaskModal.vue?vue&type=script&lang=ts"

import "./DeleteTaskModal.vue?vue&type=style&index=0&id=7c2260e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2260e4"]])

export default __exports__